// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static-react/js/" + chunkId + "." + "d8c6ec95" + ".chunk.js";
};